import z from 'zod';
import { LooseAutocomplete } from '../helpers/type-helpers';

export const ApptTypeCodeEnum = z.string();
export type ApptTypeCode = LooseAutocomplete<
  '2NDOPIN' | 'CASEREV' | 'CASEREVF' | 'CASEREVM' | 'F2F' | 'F2FDB' | 'FOLLOW-UP' | 'IMG-REVIEW' | 'NEW'
>;
